// extracted by mini-css-extract-plugin
export default {"default":"full-widget-module__default___z+Pkl"};